import React, { ReactNode, useState, useEffect } from "react";
import { SxProps } from "@mui/material";
import AuturaTextField from "./AuturaTextField";

export interface CurrencyInputProps {
  name: string;
  label: string;
  value: number;
  setValue?: (value: number) => void;
  readonly?: boolean;
  required?: boolean;
  disabled?: boolean;
  margin?: "none" | "dense" | "normal";
  variant?: "standard" | "outlined" | "filled";
  sx?: SxProps;
  endAdornment?: ReactNode;
  helperText?: string;
  validators?: string[];
  errorMessages?: string[];
}

const CurrencyInput = ({
  name,
  label,
  value,
  setValue,
  margin = "none",
  variant = "outlined",
  readonly = false,
  required = false,
  disabled = false,
  sx,
  endAdornment,
  helperText,
  validators,
  errorMessages,
}: CurrencyInputProps): ReactNode => {
  const formatValue = (value: number): string => {
    return `${(value / 100).toFixed(2)}`;
  };

  const [inputValue, setInputValue] = useState<string>(formatValue(value));

  useEffect(() => {
    if (setValue) {
      setValue(Number(inputValue.replace(/\D/g, "")));
    }
  }, [inputValue]);

  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    if (!setValue) return;
    const s = event.currentTarget.value;
    const clean = s.replace(/\D/g, "");
    const number = Number(clean);
    setInputValue(formatValue(number));
  };

  return (
    <AuturaTextField
      label={label}
      value={inputValue}
      margin={margin}
      variant={variant}
      fullWidth
      name={name}
      sx={sx}
      onChange={handleInput}
      validators={validators}
      errorMessages={errorMessages}
      readonly={readonly}
      disabled={disabled}
      helperText={helperText}
      startAdornment={"$"}
      endAdornment={endAdornment}
      required={required}
    />
  );
};

export default CurrencyInput;
